/*
 * Promote exact SKU / barcode matches to the top of the search results page.
 *
 * Why this exists:
 * Shopify's storefront /search results page ignores `options[fields]` and
 * ranks fuzzy title/description matches above an exact SKU or barcode match,
 * so scanning a barcode buries the right product at the bottom of the list.
 * The predictive `search/suggest.json` endpoint DOES honour field restriction,
 * so we query it restricted to SKU + barcode only: any product it returns is,
 * by definition, a SKU/barcode hit. We then render that product as a grid card
 * (via the Section Rendering API) and prepend it. Name searches return nothing
 * from the restricted query, so normal search results are left untouched.
 */
(function () {
  var grid = document.querySelector('#product-grid ul.product-grid');
  if (!grid) return;

  var term = (new URLSearchParams(window.location.search).get('q') || '').trim();
  if (!term) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var suggestParams = new URLSearchParams({
    q: term,
    'resources[options][fields]': 'variants.sku,variants.barcode',
    'resources[type]': 'product',
    'resources[limit]': '4',
  });

  fetch(root + 'search/suggest.json?' + suggestParams.toString())
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (data) {
      var products =
        data && data.resources && data.resources.results && data.resources.results.products;
      // No SKU/barcode match (e.g. a normal name search) → leave results as-is.
      if (!products || !products.length) return;

      var match = products[0];
      var handleUrl = match.url.split('?')[0];

      return fetch(handleUrl + '?section_id=promoted-search-card')
        .then(function (response) {
          return response.ok ? response.text() : null;
        })
        .then(function (html) {
          if (!html) return;

          var card = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('.grid__item');
          if (!card) return;

          // Remove the same product if it is already rendered further down.
          // Match the handle exactly at a path boundary so a prefix-colliding
          // handle (e.g. "...-sand" vs "...-sand-1") can't remove the wrong card.
          // Using endsWith on the "/products/<handle>" segment also tolerates a
          // locale prefix on the href (e.g. "/en-gb/products/<handle>").
          var productPath = '/products/' + match.handle;
          var existingItem = null;
          var links = grid.querySelectorAll('a[href*="' + productPath + '"]');
          for (var i = 0; i < links.length; i++) {
            var path = links[i].getAttribute('href').split('?')[0].split('#')[0].replace(/\/$/, '');
            if (path.slice(-productPath.length) === productPath) {
              existingItem = links[i].closest('.grid__item');
              break;
            }
          }
          if (existingItem) existingItem.remove();

          grid.prepend(card);
        });
    })
    .catch(function () {
      /* Non-critical enhancement — fail silently and keep native results. */
    });
})();
